import Icons, { IconsProps } from '../../Icons';

export type BrandShippingProps = IconsProps;

export function BrandShipping(props: BrandShippingProps) {
  return (
    <Icons {...props}>
      <path
        d="M0.9552 31.9999H63.0448M30.8346 0.955078L61.5833 31.9999L30.8346 63.0446M63.0448 0.955078V63.0446H0.9552V0.955078H63.0448Z"
        stroke="#DBCFB5"
      />
    </Icons>
  );
}
